export default {
  two_day_reminder_notification_email: "Two day reminder notification email",
  seven_day_reminder_notification_email:
    "Seven day reminder notification email",
  ninety_day_follow_up_completed_notification_email:
    "Ninety day follow up completed notification email",
  account_my_profile: "Account my profile",
  account_my_profile_mfa_settings: "Account my profile mfa settings",
  account_my_profile_notifications: "Account my profile notifications",
  account_my_profile_password: "Account my profile password",
  admin_account_permissions: "Admin account permissions",
  admin_consent_settings_activate: "Admin consent settings activate",
  admin_consent_settings_create: "Admin consent settings create",
  admin_consent_settings_deactivate: "Admin consent settings deactivate",
  admin_consent_settings_list: "Admin consent settings list",
  admin_consent_settings_record: "Admin consent settings record",
  admin_consent_settings_update: "Admin consent settings update",
  admin_dashboard: "Admin dashboard",
  admin_dashboard_follow_up_records: "Admin dashboard follow up records",
  admin_document_management: "Admin document management",
  admin_document_management_item: "Admin document management item",
  admin_document_management_item_activate:
    "Admin document management item activate",
  admin_document_management_item_approved:
    "Admin document management item approved",
  admin_document_management_item_create:
    "Admin document management item create",
  admin_document_management_item_deactivate:
    "Admin document management item deactivate",
  admin_document_management_item_unapproved:
    "Admin document management item unapproved",
  admin_document_management_item_update:
    "Admin document management item update",
  admin_document_public: "Admin document public",
  admin_document_training: "Admin document training",
  admin_follow_up_item: "Admin follow up item",
  admin_follow_up_item_create: "Admin follow up item create",
  admin_follow_up_item_deactivate: "Admin follow up item deactivate",
  admin_follow_up_item_lock: "Admin follow up item lock",
  admin_follow_up_item_unlock: "Admin follow up item unlock",
  admin_follow_up_item_update: "Admin follow up item update",
  admin_general_settings_activate: "Admin general settings activate",
  admin_general_settings_create: "Admin general settings create",
  admin_general_settings_deactivate: "Admin general settings deactivate",
  admin_general_settings_list: "Admin general settings list",
  admin_general_settings_record: "Admin general settings record",
  admin_general_settings_update: "Admin general settings update",
  admin_permissions_list: "Admin permissions list",
  admin_sae_item: "Admin sae item",
  admin_sae_item_activated: "Admin sae item activated",
  admin_sae_item_create: "Admin sae item create",
  admin_sae_item_deactivated: "Admin sae item deactivated",
  admin_sae_item_lock: "Admin sae item lock",
  admin_sae_item_unlock: "Admin sae item unlock",
  admin_sae_item_update: "Admin sae item update",
  admin_sae_list: "Admin sae list",
  admin_site_create: "Admin site create",
  admin_site_item: "Admin site item",
  admin_site_item_activate: "Admin site item activate",
  admin_site_item_deactivate: "Admin site item deactivate",
  admin_site_item_update: "Admin site item update",
  admin_site_list: "Admin site list",
  admin_user_roles_create: "Admin user roles create",
  admin_user_roles_item: "Admin user roles item",
  admin_user_roles_item_activate: "Admin user roles item activate",
  admin_user_roles_item_deactivate: "Admin user roles item deactivate",
  admin_user_roles_item_update: "Admin user roles item update",
  admin_user_roles_list: "Admin user roles list",
  admin_user_site_access_activate: "Admin user site access activate",
  admin_user_site_access_create: "Admin user site access create",
  admin_user_site_access_deactivate: "Admin user site access deactivate",
  admin_user_site_access_update: "Admin user site access update",
  admin_users_item: "Admin users item",
  admin_users_item_activate: "Admin users item activate",
  admin_users_item_create: "Admin users item create",
  admin_users_item_deactivate: "Admin users item deactivate",
  admin_users_item_update: "Admin users item update",
  admin_users_list: "Admin users list",
  consent: "Consent",
  consent_recorded_notification_email: "Consent recorded notification email",
  consent_step_1: "Consent step 1",
  consent_step_3_electronic: "Consent step 3 electronic",
  consent_step_3_paper: "Consent step 3 paper",
  contact_us: "Contact us",
  contact_us_email: "Contact us email",
  death_occurred_notification_email: "Death occurred notification email",
  document_approved_notification_email: "Document approved notification email",
  document_pending_approval_notification_email:
    "Document pending approval notification email",
  new_site_notification_email: "New site notification email",
  new_user_welcome_email: "New user welcome email",
  owned_site_list: "Owned site list",
  patient_item: "Patient item",
  patient_item_activate: "Patient item activate",
  patient_item_deactivate: "Patient item deactivate",
  patient_list: "Patient list",
  patient_list_by_event: "Patient list by event",
  patient_list_by_site: "Patient list by site",
  patient_profile_item: "Patient profile item",
  patient_profile_item_create: "Patient profile item create",
  patient_profile_item_lock: "Patient profile item lock",
  patient_profile_item_unlock: "Patient profile item unlock",
  patient_profile_item_update: "Patient profile item update",
  patient_profile_list: "Patient profile list",
  patient_profile_preview_item_deactivate:
    "Patient profile preview item deactivate",
  randomization: "Randomization",
  randomization_follow_up_create: "Randomization follow up create",
  report_subject_summary_notification_email:
    "Report subject summary notification email",
  resource_permission_check: "Resource permission check",
  sae_occurred_notification_email: "Sae occurred notification email",
  sae_reporting: "Sae reporting",
  sae_reporting_step_1: "Sae reporting step 1",
  sae_reporting_step_2: "Sae reporting step 2",
  site_access_list: "Site access list",
  site_suspended_notification_email: "Site suspended notification email",
  sms: "Sms",
  subject_randomization_detailed_email: "Subject randomization detailed email",
  subject_randomization_summary_email: "Subject randomization summary email",
  trial_documents: "Trial documents",
  user_login: "User login",
  user_login_validate_mfa_code: "User login validate mfa code",
  user_login_with_mfa: "User login with mfa",
  user_login_with_mfa_email: "User login with mfa email",
  user_login_with_mfa_sms: "User login with mfa sms",
  user_login_without_mfa: "User login without mfa",
  user_logout: "User logout",
  user_recover: "User recover",
  user_recover_confirm_token: "User recover confirm token",
  user_recover_email: "User recover email",
  user_recover_update_password: "User recover update password",
  validate_randomization_notification_email:
    "Validate randomization notification email",
  validation: "Validation",
  validation_differs_from_randomization_notification_email:
    "Validation differs from randomization notification email",
  validation_protocol_deviation_notification_email:
    "Validation protocol deviation notification email",
  validation_step_1: "Validation step 1",
  validation_step_3: "Validation step 3",
  audit_log_list: "Audit Log List",
  audit_log_item: "Audit Log Item",
  audit_log_item_edit: "Audit Log Item Edit",
  audit_log_item_deactivate: "Audit Log Item Deactivate",
  audit_log_item_activate: "Audit Log Item Activate",
  audit_log_item_reviewed: "Audit Log Item Reviewed",
  audit_log_item_unreviewed: "Audit Log Item Unreviewed",
  audit_log_item_email_resend: "Audit Log Item Email Resend",
  randomization_rate_limit: "Randomization Rate Limit",
  audit_log_simulation_generate_csv: "Audit Log Simulation Generated CSV file",
  audit_log_simulation_list: "Audit Log Simulation List",
  audit_log_simulation_item_create: "Audit Log Simulation Item Create",
  audit_log_simulation_item: "Audit Log Simulation Item",
  audit_log_simulation_item_update: "Audit Log Simulation Item Update",
  audit_log_simulation_item_deactivate: "Audit Log Simulation Item Deactivate",
  audit_log_simulation_item_activate: "Audit Log Simulation Item Activate",
  newsletter_email: "Newsletter email",
};



// WEBPACK FOOTER //
// ./src/containers/AuditLogs/actionTypes.js